export const bonuses = [
  {
    id: 1,
    title: "Manual Completo de Mecánica Industrial",
    description: "Una guía exhaustiva con todos los fundamentos, fórmulas y procedimientos paso a paso para el mantenimiento industrial moderno.",
    image: "https://cdn.magicpatterns.com/uploads/4wGfWu38atLpQmV3CKxRgT/ChatGPT_Image_8_ago_2026,_20_11_08.webp",
    benefits: [
      "Más de 200 páginas de contenido técnico",
      "Ilustraciones y diagramas detallados",
      "Formato digital listo para imprimir"
    ]
  },
  {
    id: 2,
    title: "Tabla de Lubricación y Especificaciones Técnicas",
    description: "El recurso indispensable para seleccionar el lubricante correcto según el tipo de máquina, temperatura y carga de trabajo.",
    image: "https://cdn.magicpatterns.com/uploads/5pCW2a1rGBB4epjTpa4jNY/ChatGPT_Image_8_ago_2026,_20_13_42.webp",
    benefits: [
      "Equivalencias entre marcas principales",
      "Intervalos de lubricación recomendados",
      "Guía de viscosidad y aditivos"
    ]
  },
  {
    id: 3,
    title: "Lista de Verificación de Inspección Preventiva",
    description: "Checklists listos para usar en tus rutinas diarias, semanales y mensuales de mantenimiento preventivo.",
    image: "https://cdn.magicpatterns.com/uploads/5L3KfejrNzJnkr2L2xMigz/ChatGPT_Image_8_ago_2026,_20_14_42.webp",
    benefits: [
      "Formatos estandarizados profesionales",
      "Puntos críticos de inspección por equipo",
      "Prevención efectiva de fallas catastróficas"
    ]
  },
  {
    id: 4,
    title: "Guía de Diagnóstico de Fallas",
    description: "Aprende a identificar rápidamente el origen de ruidos, vibraciones y sobrecalentamientos en equipos rotativos.",
    image: "https://cdn.magicpatterns.com/uploads/3xh5g9Qn7frQCNkbABP4U3/ChatGPT_Image_8_ago_2026,_20_16_43.webp",
    benefits: [
      "Árboles de decisión para solución de problemas",
      "Síntomas comunes y sus causas probables",
      "Técnicas de inspección visual y auditiva"
    ]
  },
  {
    id: 5,
    title: "Manual de Herramientas del Mecánico Industrial",
    description: "Conoce a fondo el uso correcto, cuidado y calibración de las herramientas manuales y de medición de precisión.",
    image: "https://cdn.magicpatterns.com/uploads/6Hqm9WJtABRdoLG79rH6oG/ChatGPT_Image_8_ago_2026,_20_17_40.webp",
    benefits: [
      "Uso correcto de calibres y micrómetros",
      "Selección de herramientas por tarea",
      "Normas de seguridad en el uso"
    ]
  },
  {
    id: 6,
    title: "Modelos de Órdenes de Trabajo Personalizables",
    description: "Plantillas profesionales en formato editable para documentar tus intervenciones y profesionalizar tu servicio.",
    image: "https://cdn.magicpatterns.com/uploads/cdficenzWrJbtjRRKoM3SE/ChatGPT_Image_8_ago_2026,_20_24_12.webp",
    benefits: [
      "Formatos en Word y Excel",
      "Registro de repuestos y tiempos",
      "Historial de mantenimiento estructurado"
    ]
  },
  {
    id: 7,
    title: "Guía de Símbolos Hidráulicos y Neumáticos",
    description: "Domina la lectura de planos y diagramas de circuitos de potencia fluida con esta guía de referencia rápida.",
    image: "https://cdn.magicpatterns.com/uploads/7XytDCxMLk6g2haE6iro1L/ChatGPT_Image_8_ago_2026,_20_31_53.webp",
    benefits: [
      "Simbología normalizada ISO/DIN",
      "Ejemplos de circuitos básicos",
      "Identificación rápida de componentes"
    ]
  },
  {
    id: 8,
    title: "Manual de Rodamientos y Transmisiones",
    description: "Todo lo que necesitas saber sobre montaje, desmontaje, ajustes y tolerancias en elementos de transmisión de potencia.",
    image: "https://cdn.magicpatterns.com/uploads/reAq6aDcAZCjhhou4oye1q/ChatGPT_Image_8_ago_2026,_20_33_04.webp",
    benefits: [
      "Técnicas de montaje en frío y en caliente",
      "Alineación de poleas y acoplamientos",
      "Cálculo de tensiones en correas"
    ]
  },
  {
    id: 9,
    title: "Kit de Análisis de Causa Raíz",
    description: "Metodologías probadas (5 Porqués, Ishikawa) para investigar fallas recurrentes y eliminarlas definitivamente.",
    image: "https://cdn.magicpatterns.com/uploads/fFJzuGrd4hTB3bWNUWQ1Xt/ChatGPT_Image_8_ago_2026,_20_34_28.webp",
    benefits: [
      "Plantillas de investigación de incidentes",
      "Ejemplos reales de la industria",
      "Mejora continua de la confiabilidad"
    ]
  },
  {
    id: 10,
    title: "Preparación para Procesos de Selección y Entrevistas Laborales",
    description: "Destaca en tus entrevistas técnicas con las preguntas más frecuentes y consejos para presentar tu experiencia.",
    image: "https://cdn.magicpatterns.com/uploads/3PdLFF7cd7dEdLqnuVmhN2/ChatGPT_Image_8_ago_2026,_20_35_49.webp",
    benefits: [
      "Preguntas técnicas resueltas",
      "Tips para armar un CV de alto impacto",
      "Cómo negociar tu salario"
    ]
  }
];

export const faqs = [
  {
    question: "¿Necesito experiencia previa?",
    answer: "No, el programa está diseñado desde cero. Comenzamos con los fundamentos básicos y avanzamos progresivamente hacia temas más complejos, ideal tanto para principiantes como para quienes desean repasar conceptos."
  },
  {
    question: "¿Cómo recibo el acceso?",
    answer: "Inmediatamente después de confirmar tu pago, recibirás un correo electrónico con tus credenciales de acceso (usuario y contraseña) y el enlace a nuestra plataforma educativa privada."
  },
  {
    question: "¿Durante cuánto tiempo puedo acceder?",
    answer: "¡El acceso es de por vida! Podrás ingresar al material, a las actualizaciones futuras y a los bonos todas las veces que quieras, sin límite de tiempo ni pagos recurrentes."
  },
  {
    question: "¿El certificado es oficial?",
    answer: "El certificado acredita la finalización de nuestro programa de formación profesional privada. Es un excelente complemento para tu currículum y perfil de LinkedIn, demostrando tu compromiso con la capacitación continua, aunque no reemplaza una titulación de grado oficial."
  },
  {
    question: "¿Cómo funcionan los bonos?",
    answer: "Todos los bonos digitales (manuales, guías, plantillas) estarán disponibles para su descarga directa dentro de la misma plataforma donde se encuentra el contenido principal del curso."
  },
  {
    question: "¿Qué sucede después de comprar?",
    answer: "Recibirás un email de bienvenida con las instrucciones. Podrás crear tu perfil, acceder al primer módulo inmediatamente y unirte a nuestra comunidad de estudiantes."
  }
];

export const testimonials = [
  {
    name: "Carlos Mendoza",
    occupation: "Técnico de Mantenimiento",
    comment: "El material es súper práctico y va directo al grano. Me ayudó muchísimo a entender mejor los sistemas hidráulicos que veo todos los días en la planta. Totalmente recomendado.",
    image: "https://cdn.magicpatterns.com/uploads/neyLVLsZPViN4grxUCt6QP/ChatGPT_Image_9_ago_2026,_00_30_04.webp"
  },
  {
    name: "Andrés Ramírez",
    occupation: "Operador de Maquinaria",
    comment: "Buscaba algo para dar el salto a mantenimiento y este curso fue la clave. Los manuales que vienen de bono son una herramienta que uso casi a diario en mi trabajo nuevo.",
    image: "https://cdn.magicpatterns.com/uploads/pph1gdHy6aHfUcPCmdavF6/ChatGPT_Image_9_ago_2026,_00_35_33.webp"
  },
  {
    name: "Luis Herrera",
    occupation: "Estudiante de Ingeniería",
    comment: "Excelente complemento para la facultad. Ver la aplicación real y práctica de los conceptos teóricos me aclaró muchas dudas. La calidad de los videos y explicaciones es de primera.",
    image: "https://cdn.magicpatterns.com/uploads/7wVhGXNNxkThUiKPqspSz7/ChatGPT_Image_9_ago_2026,_00_35_31.webp"
  },
  {
    name: "Miguel Torres",
    occupation: "Mecánico Independiente",
    comment: "La inversión se paga sola. Solo con las plantillas de órdenes de trabajo y las guías de diagnóstico ya amorticé el costo. Muy profesional todo el contenido.",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&fit=crop&crop=faces"
  }
];
